interface HelpCenterLocation {
  hostname: string
  origin: string
}

const TRUSTED_HELP_HOST_PATTERN = /^help\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.enlil\.io$/;
const TRUSTED_EXTERNAL_HOSTS = new Set(['shifamed.atlassian.net']);

const environmentPrefix = (hostname: string): string => {
  const environment = hostname.split('.').reverse()[2];
  return environment ? `${environment}.` : '';
};

const resolveHelpCenterUrl = (
  urlTemplate: string,
  location: HelpCenterLocation = window.location,
): string => {
  const interpolated = urlTemplate.replace('{env}', environmentPrefix(location.hostname));
  const candidate = interpolated.startsWith('//')
    ? `https:${interpolated}`
    : new URL(interpolated, location.origin).href;
  const url = new URL(candidate);

  if (url.protocol !== 'https:') {
    throw new TypeError('Help Center URL must use HTTPS');
  }

  if (
    url.hostname !== 'help.enlil.io'
    && !TRUSTED_HELP_HOST_PATTERN.test(url.hostname)
    && !TRUSTED_EXTERNAL_HOSTS.has(url.hostname)
  ) {
    throw new TypeError('Help Center URL hostname is not trusted');
  }

  return url.href;
};

export default resolveHelpCenterUrl;
